export default class MetricCalculationConfigType {
    public static NumberMetric: number = 0;
    public static OperatorAdd: number = 1;
    public static OperatorMinus: number = 2;
    public static OperatorDivide: number = 3;
    public static OperatorMultiply: number = 4;
}